// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"eR-z","carouselContainer":"fR-z"};